// MessageCategoryTabContent.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import SortButton from '../container/SortButton.js';
import FeedComponent from '../container/FeedComponent.js';
import Loading from '../component/Loading.jsx';

import { CategoryListType } from '../resource/categoryConstants.js';
import { ButtonId } from '../resource/trackingConstants.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';

import { textColor, footerNavigationHeight } from '../style/variables.js';
import media from '../style/media.js';

import EmptyIconSrouce from '../../img/img-empty-category-feed.svg';

export class MessageCategoryTabContent extends React.PureComponent {
  locationState = {};
  getIsEmpty = () => {
    const { categoryFeedName, isFirstPageFetched, postIds } = this.props;
    return (
      !categoryFeedName ||
      (categoryFeedName && isFirstPageFetched && postIds.length === 0)
    );
  };
  renderLoading = () => {
    return (
      <ItemWrapper>
        <LoadingWrapper>
          <Loading />
        </LoadingWrapper>
      </ItemWrapper>
    );
  };
  renderEmpty = () => {
    const { t } = this.props;
    return (
      <EmptyWrapper>
        <EmptyIcon src={EmptyIconSrouce} />
        {t('it_is_empty_here', {
          ns: TranslationNamespace.GENERAL,
        })}
      </EmptyWrapper>
    );
  };
  renderFeed = () => {
    const { feedNameWithQuery, listType, listSelectPath } = this.props;
    const componentProps = {
      category: feedNameWithQuery,
      categoryIndex: 0,
    };
    switch (listType) {
      case CategoryListType.FLIX:
        componentProps.shouldIncrementHeading = true;
        componentProps.shouldTrackProfilePostEvent = true;
        componentProps.shouldShowAuthor = false;
        break;
      case CategoryListType.STORY:
        componentProps.locationState = {
          listPath: listSelectPath,
        };
        break;
      case CategoryListType.SHORT:
        // TODO: Refactor, rename later to remove this prop
        componentProps.isProfileCategory = true;
        break;
      case CategoryListType.IMAGE:
        componentProps.shouldShowUsername = true;
        componentProps.shouldShowAvatar = true;
        break;
      default:
        break;
    }
    return <FeedComponent {...componentProps} />;
  };
  renderSorting = () => {
    const { feedNameRemoteConfigKey, categoryFeedName } = this.props;
    return (
      <SortingWrapper>
        {!this.getIsEmpty() && (
          <SortButton
            remoteConfigKeyName={feedNameRemoteConfigKey}
            baseFeedName={categoryFeedName}
            mixpanelButtonId={ButtonId.Category.Sorting}
            defaultItemI18nKey={'general_sorting'}
          />
        )}
      </SortingWrapper>
    );
  };
  render() {
    return (
      <Wrapper>
        {this.renderSorting()}
        {this.getIsEmpty() ? this.renderEmpty() : this.renderFeed()}
      </Wrapper>
    );
  }
}

MessageCategoryTabContent.propTypes = {
  categoryId: PropTypes.string,
  categoryFeedName: PropTypes.string,
  feedNameWithQuery: PropTypes.string,
  feedNameRemoteConfigKey: PropTypes.string,
  listType: PropTypes.string,
  isFirstPageFetched: PropTypes.bool,
  listSelectPath: PropTypes.array,
  postIds: PropTypes.array,
  t: PropTypes.func.isRequired,
};

MessageCategoryTabContent.defaultProps = {
  categoryId: null,
  categoryFeedName: null,
  feedNameWithQuery: null,
  feedNameRemoteConfigKey: null,
  listType: null,
  isFirstPageFetched: false,
  listSelectPath: [],
  postIds: [],
};

const Wrapper = styled.div`
  padding-bottom: ${footerNavigationHeight}px;
`;

const SortingWrapper = styled.div`
  padding: 20px 12px;
  display: flex;
  justify-content: end;
  align-items: center;
  > * {
    :first-child {
      margin-left: 0px;
    }
    margin-left: 8px;
  }
  ${media.mobile`
    padding: 8px 16px;
  `};
  :empty {
    padding: 0px;
    margin-bottom: 20px;
    ${media.mobile`
      margin-bottom: 12px;
    `};
  }
`;

const EmptyWrapper = styled.div`
  padding-top: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 14px;
  color: ${textColor.black};
`;

const EmptyIcon = styled.img`
  margin-bottom: 12px;
  width: 90px;
  height: 92px;
  object-fit: contain;
`;

const ItemWrapper = styled.div`
  position: relative;
  padding-top: 100%;
`;

const LoadingWrapper = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default withTranslation()(MessageCategoryTabContent);
